import {HttpHandler} from "../../../utils/handler/HttpHandler";

export class MarginCallLoanService {
    constructor() {
        this.httpHandler = new HttpHandler();
        this.axiosInstance = this.httpHandler.createInstance('/bilateral/loan/marginCall');
    }

    assignCollateralsMarginCall(params) {
        return this.axiosInstance({
            url: '/' + params.loanId,
            method: 'post',
            data: {
                collateralMovementList: params.collateralMovementList
            }
        }).then(res => res);
    }

}